import { Form, Input, Button, message as AntdMessage, Typography } from 'antd';
import "./Verification.css"
import { useNavigate, useParams } from 'react-router-dom';
import { verifyOrganization } from '../../api/verification-api-functions';
const {Title} = Typography;

const Verification = () => {
    const { id } = useParams()
    const navigate = useNavigate();


    const handleVerification = async (values) => {
        const { success, message } = await verifyOrganization(id, values)
        if (success) {
            AntdMessage.success(message);
            navigate(`/login`);
        } else {
            AntdMessage.error(message);
        }
    };

    return (
        <div className='verification-page'>
            <div className="card">
                <div className="content">

                    <Title level={4} className="text-center mb-4" style={{color: "white"}}>Verify Your Email</Title>
                    <Form
                        name="basic"
                        onFinish={handleVerification}
                        style={{ maxWidth: '300px', margin: 'auto' }}
                    >
                        <div>
                            <div>
                                <Typography className='mb-1' style={{ color: "#fff", }}>Enter verification code:</Typography>
                                <Form.Item
                                    name="verification_code"
                                    rules={[{ required: true, message: 'Please enter the verification code!' }]}
                                    className='verify-custom-label'
                                >
                                    <Input placeholder='Enter your code' style={{background: "#000", color: "white"}}/>
                                </Form.Item>
                            </div>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" style={{ width: "100%" }}>
                                    Verify
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    )
}

export default Verification
